import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { Toaster } from "sonner";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ProposalsPage from "@/pages/ProposalsPage";
import ProposalWizard from "@/pages/ProposalWizard";
import ProposalView from "@/pages/ProposalView";
import LibrariesPage from "@/pages/LibrariesPage";
import AuditLogPage from "@/pages/AuditLogPage";
import UsersPage from "@/pages/UsersPage";
import HelpPage from "@/pages/HelpPage";
import BrandingPage from "@/pages/BrandingPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import ProfilePage from "@/pages/ProfilePage";
import DocumentsPage from "@/pages/DocumentsPage";
import PublicSignPage from "@/pages/PublicSignPage";
import ProposalPreview from "@/pages/ProposalPreview";
import RevenueTrackerPage from "@/pages/RevenueTrackerPage";
import PipelineSummaryPage from "@/pages/PipelineSummaryPage";
import JiraSummaryPage from "@/pages/JiraSummaryPage";
import ConnectClaudePage from "@/pages/ConnectClaudePage";
import TicketsPage from "@/pages/TicketsPage";
import OutreachPage from "@/pages/OutreachPage";
import CrmPage from "@/pages/CrmPage";
import TeamPage from "@/pages/TeamPage";
import TeamMemberPage from "@/pages/TeamMemberPage";
import AppLayout from "@/components/AppLayout";
import InstallPWA from "@/components/InstallPWA";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}<InstallPWA /></AppLayout>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/sign/:token" element={<PublicSignPage />} />
          <Route path="/" element={<Protected><DashboardPage /></Protected>} />
          <Route path="/proposals" element={<Protected><ProposalsPage /></Protected>} />
          <Route path="/proposals/new" element={<Protected><ProposalWizard /></Protected>} />
          <Route path="/proposals/:id" element={<Protected><ProposalView /></Protected>} />
          <Route path="/proposals/:id/preview" element={<Protected><ProposalPreview /></Protected>} />
          <Route path="/library" element={<Protected><LibrariesPage /></Protected>} />
          <Route path="/audit" element={<Protected><AuditLogPage /></Protected>} />
          <Route path="/users" element={<Protected><UsersPage /></Protected>} />
          <Route path="/branding" element={<Protected><BrandingPage /></Protected>} />
          <Route path="/integrations" element={<Protected><IntegrationsPage /></Protected>} />
          <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
          <Route path="/documents" element={<Protected><DocumentsPage /></Protected>} />
          <Route path="/revenue" element={<Protected><RevenueTrackerPage /></Protected>} />
          <Route path="/pipeline" element={<Protected><PipelineSummaryPage /></Protected>} />
          <Route path="/projects" element={<Protected><JiraSummaryPage /></Protected>} />
          <Route path="/connect-claude" element={<Protected><ConnectClaudePage /></Protected>} />
          <Route path="/tickets" element={<Protected><TicketsPage /></Protected>} />
          <Route path="/outreach" element={<Protected><OutreachPage /></Protected>} />
          <Route path="/crm" element={<Protected><CrmPage /></Protected>} />
          <Route path="/team" element={<Protected><TeamPage /></Protected>} />
          <Route path="/team/:userId" element={<Protected><TeamMemberPage /></Protected>} />
          <Route path="/help" element={<Protected><HelpPage /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
